import { Schema } from "rsuite";


const { StringType, NumberType } = Schema.Types;

export const TRAFFIC_LIMIT_COL_WIDTH = {
    INDEX: 36,
    SENDERID: 220,
    DAY: 80,
    HOUR: 80,
    ACTIONS: 120
};

export const TRAFFIC_LIMIT_UNEDITABLE = 0;
export const TRAFFIC_LIMIT_CREATING_CODE = 1;
export const TRAFFIC_LIMIT_EDITING_CODE = 2;

export const dayModel = Schema.Model({
    day: NumberType()
        .min(1, "Minimum 1")
        .max(10000000, "Maximum 10000000")
        .isRequired("This field is required"),
});

export const hourModel = Schema.Model({
    hour: NumberType()
        .min(1, "Minimum 1")
        .max(10000000, "Maximum 10000000")
        .isRequired("This field is required"),
});

export const supplierIdModel = Schema.Model({
    senderid: StringType()
        .maxLength(40, "Maximum 40"),
});

export const formHttpIpModel = Schema.Model({
    ip: StringType()
        .isRequired("Required")
        .pattern(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            "Please enter legal IP Address"
        )
});

export const ipRegex =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const collectErrorFields = (checkedFormValue) => {
    return Object.keys(checkedFormValue).filter((checkedKey) => {
        return checkedFormValue[checkedKey]?.hasError;
    });
};

export const withoutErrorKey = (errorByKey = {}, keyToRemove) => {
    return Object.keys(errorByKey)
        .filter((errorKey) => parseInt(errorKey, 10) !== parseInt(keyToRemove, 10))
        .reduce((result, currentKey) => {
            result[currentKey] = errorByKey[currentKey];
            return result;
        }, {});
};

export const updateSectionErrors = (setError, sectionKey, rowKey, errorFields) => {
    setError((prevValue) => {
        const prevErrors = prevValue[sectionKey] || {};
        const prevFilteredErrors = withoutErrorKey(prevErrors, rowKey);

        return {
            ...prevValue,
            [sectionKey]: {
                ...prevFilteredErrors,
                [rowKey]: errorFields
            }
        };
    });
};

export const applyValidationErrors = (setError, sectionKey, rowKey, checkedFormValue) => {
    const errorFields = collectErrorFields(checkedFormValue);
    updateSectionErrors(setError, sectionKey, rowKey, errorFields);
    return errorFields;
};

export const clearSectionRow = (setError, sectionKey, rowKey) => {
    setError((prevValue) => {
        const prevErrors = prevValue[sectionKey] || {};
        const nextErrors = withoutErrorKey(prevErrors, rowKey);

        return {
            ...prevValue,
            [sectionKey]: nextErrors
        };
    });
};

export const replaceByIndex = (list, idx, value) => {
    const nextList = list.map((x) => x);
    nextList[idx] = value;
    return nextList;
};

export const removeByIndex = (list, idx) => {
    const nextList = list.map((x) => x);
    nextList.splice(idx, 1);
    return nextList;
};

export const normalizeTrafficLimitValue = (value, isTransitTrunks) => {
    return {
        ...value,
        ...(value?.day ? { day: parseInt(value.day, 10) } : { day: value.day }),
        ...(isTransitTrunks ? {} : value?.hour ? { hour: parseInt(value.hour, 10) } : { hour: value.hour }),
    };
};

export const getNextTrafficLimitKey = (trafficLimitEditData) => {
    const keySortedList = Object.keys(trafficLimitEditData)
        .filter((key) => key.startsWith("new"))
        .sort((a, b) => a > b);

    const biggestKeySplittedList = keySortedList.length ? keySortedList[keySortedList.length - 1].split("new") : [];
    const biggestKey = biggestKeySplittedList.length ? biggestKeySplittedList[biggestKeySplittedList.length - 1] : 0;
    const biggestKeyCount = biggestKey ? parseInt(biggestKey, 10) : 0;
    const newKeyCount = biggestKeyCount + 1;

    return `new${newKeyCount || ""}`;
};

export const getTrafficLimitSaveDisabled = ({
    defaultTrafficLimit,
    trafficLimit,
    isTransitTrunks
}) => {
    const ganDisabled = (
        defaultTrafficLimit.senderid === trafficLimit.senderid
        && defaultTrafficLimit.day === trafficLimit.day
        && defaultTrafficLimit.hour === trafficLimit.hour
    ) || (!trafficLimit.day || !trafficLimit.hour);

    const transitDisabled = (
        defaultTrafficLimit.senderid === trafficLimit.senderid
        && defaultTrafficLimit.day === trafficLimit.day
    ) || !trafficLimit.day;

    return isTransitTrunks ? transitDisabled : ganDisabled;
};

export const upsertTrafficLimitByKey = (list, trafficLimit) => {
    const prevTrafficLimit = list.filter((value) => value.key !== trafficLimit.key);
    return [...prevTrafficLimit, trafficLimit].sort((a, b) => a.key > b.key);
};

export const replaceTrafficLimitByKey = (list, key, replacementValue) => {
    return list.reduce((result, value, idx) => {
        result[idx] = value.key === key ? replacementValue : value;
        return result;
    }, []);
};
